import { r as registerInstance, h, H as Host } from './index-2b2e631a.js';
import { s as state } from './state-3cc1e9a3.js';

const searchFacetsCss = ":host{display:block}";

let SearchFacets = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    // Determines whether to show the number of search results that match each facet
    this.showCounts = true;
  }
  /**
   * Render element
   */
  render() {
    // Determine if there is both a search response and search facets
    if (state.searchResponse && state.searchResponse.Facets) {
      // Return element
      return (h(Host, { class: "search-facets", role: "complementary", "aria-label": "Refine your search results" }, 
      // Loop facets
      Object.keys(state.searchResponse.Facets).map((facetKey) => {
        // Retrieve facet
        const facet = state.searchResponse.Facets[facetKey];
        // Return element
        return (h("search-facet", { facetKey: facetKey, showCount: this.showCounts }, h("legend", null, facet.FieldName)));
      })));
    }
  }
};
SearchFacets.style = searchFacetsCss;

export { SearchFacets as search_facets };
